module.exports = __webpack_public_path__ + "img/sup_cardsetting_bank3.d7dcb0e9.jpg";